import React, { useState } from "react";
import Headline from "./Headline";
import { Button, Flex, Form, Input, Modal, notification, Radio, RadioChangeEvent } from "antd";
import HomeLink from "../../widgets/HomeLink";
import { Link } from "react-router-dom";
import CustomerApi from "../../api-services/customer-api.service";
import { useAuth } from "../../services/AuthContext";


const validateMessages = {
  required: '${label} is required!',
  types: {
    email: '${label} is not a valid email!'
  },
};

type FieldType = {
  username?: string;
  password?: string;
  email?: string;
};

const bannerPath = '/iceholidays-assets/images/partner_signin_cover.png';
const breadcrumbs = [
  { title: <HomeLink/>},
  { title: 'Sign In' }
]

const SignInPage: React.FC = () => {
  const [signInForm] = Form.useForm();
  const [linkForm] = Form.useForm();

  const [forgotPasswordModalVisible, showForgotPasswordModal] = useState(false);
  const [signInOption, setSignInOption] = useState("default");

  const closeModal = () => {
    showForgotPasswordModal(false);
  }

  const sendRequest = (formValues) => {
    CustomerApi.forgotPassword(formValues.email)
      .then(success => {
        if(success){
          closeModal();
          Modal.success({
            content: "If your email exists in our database, you will receive a password recovery link at your email address in a few minutes."
          });
        }
      })
      .catch(error => {
        notification.error({ message: error.response.data.error});
      });
  };

  const changeSignInOption = (e: RadioChangeEvent) => {
    setSignInOption(e.target.value);
  }

  const renderContent = () => {
    const { login } = useAuth();

    const requestLink = (formValues) => {
      CustomerApi.requestLink(formValues)
      .then(success => {
        if(success){
          Modal.success({
            content: "If your email exists in our database, you will receive a sign-in link at your email address in a few minutes."
          });
          linkForm?.resetFields();
        }
      })
      .catch(error => {
        notification.error({ message: error.response.data.error});
      });
    }

    switch(signInOption) {
      case "link":
       return (
        <Form
          form={linkForm}
          autoComplete="off"
          layout="vertical"
          variant="filled"
          onFinish={requestLink}
        >                      
          <Form.Item<FieldType>
            label="Email Address"
            name="email"
            rules={[{ required: true, message: 'Please input your email address' }, { type: "email" }]}
          >
            <Input placeholder="Enter Email Address"/>
          </Form.Item>

          <Flex align="center" justify="center">
            <Button type="primary" htmlType="submit">
              Request Link
            </Button>
          </Flex>
        </Form>
       )
      default:
       return (
        <Form
          form={signInForm}
          autoComplete="off"
          layout="vertical"
          variant="filled"
          onFinish={login}
        >                       
          <Form.Item<FieldType>
            label="Email Address"
            name="email"
            rules={[{ required: true, message: 'Please input your email address' }, { type: "email" }]}
          >
            <Input placeholder="Enter Email Address"/>
          </Form.Item>

          <Form.Item<FieldType>
            label="Password"
            name="password"
            rules={[{ required: true, message: 'Please input your password' }]}
          >
            <Input.Password placeholder="Enter Password"/>
          </Form.Item>

          <p id="forgot-password" onClick={()=>showForgotPasswordModal(true)}>forgot Password?</p>

          <Flex align="center" justify="center">
            <Button type="primary" htmlType="submit">
              Sign In
            </Button>
          </Flex>
        </Form>
       )
    }
  }


  return (
    <div id="sign-in" className="gd-series-tour-page signin-page">
      <Headline showSearch={false} bannerImage={bannerPath} breadcrumbs={breadcrumbs}>
        <span className="title">
          Sign In
        </span>
      </Headline>

      <div className="gd-series-tour-page_body">
        <div className="signin-page-form">
          
          <Flex justify="center" vertical className="signin-page-form-header">
            <label>Sign In</label>

            <Radio.Group className="custom-tab-pill" value={signInOption} onChange={changeSignInOption}>
              <Radio.Button value="default">Via Email & Password</Radio.Button>
              <Radio.Button value="link">Via Authentication Link</Radio.Button>
            </Radio.Group>
          </Flex>

          {renderContent()}

          <Flex align="center" justify="center">
            <div id="partner-sign-in-link">
              <span>One of Our Partners? </span> <Link to="/web/partner-sign-in">Sign In Here</Link>
            </div>
          </Flex>

          {/* <div id="download-options">
            <div>
              <h2>Download the App</h2>
              <p>Scan me now</p>
            </div>

            <img id="qr" src='/iceholidays-assets/images/download_qr.png'/>

            <small>or</small>

            <Space size={14} direction="vertical" align="center">
              <a target="_blank" href="https://apps.apple.com/my/app/golden-destinations/id1446862869"><img src="/iceholidays-assets/images/social/app_store_black.png"/></a>
              <a target="_blank" href="/"><img src="/iceholidays-assets/images/social/google_play_black.png"/></a>
            </Space>
          </div> */}
        </div>
      </div>

       <Modal title={
          <>
            <h2>Forgot Password</h2>
            <p>To reset your password, please enter vour email address</p>
          </>
        } open={forgotPasswordModalVisible} onCancel={closeModal} footer={null} width={800} centered className="forgot_password_modal">          
            <Form
              autoComplete="off"
              layout="vertical"
              variant="filled"
              validateMessages={validateMessages}
              onFinish={sendRequest}
              className="forgot-password-form"
            >
              <Form.Item label="Email" name="email" required>
                <Input placeholder="Enter Email" />
              </Form.Item>

              <Flex align="center" justify="center">
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Flex>
            </Form>
        </Modal>

    </div>
  )
}

export default SignInPage;